import { CSSProperties, useContext, useEffect } from 'react'

import { ActiveAssetContext, CLUSTER_MARKER } from '@/feature/observatory'
import { calculateZoomForBounds, MapContext, MapMarker } from '@/feature/map'

import styles from './ClusterMarker.module.css'

export type ClusterMarkerProps<T> = {
  position: {
    lat: number
    lng: number
  }
  items: Set<T>
}

export type PositionalData = {
  lat: number
  lon: number
  sourceId: string
}

export const ClusterMarker = <T extends PositionalData = PositionalData>({
  position,
  items,
}: ClusterMarkerProps<T>) => {
  const map = useContext(MapContext)
  const { activeAsset } = useContext(ActiveAssetContext)

  const zoomIntoCluster = () => {
    if (map?.map) {
      const bounds = new window.google.maps.LatLngBounds()
      items.forEach((item) => {
        bounds.extend({ lat: item.lat, lng: item.lon })
      })

      const targetZoom = calculateZoomForBounds(bounds, map.map.getDiv().getBoundingClientRect())
      map.panTo({
        position: bounds.getCenter(),
        zoom: targetZoom - 0.1,
      })
    }
  }

  useEffect(() => {
    for (const item of items) {
      if (item.sourceId === activeAsset?.vehicleBridgeId) {
        zoomIntoCluster()
        break
      }
    }
  }, [activeAsset])

  return (
    <MapMarker position={position} onClick={zoomIntoCluster} zIndex={CLUSTER_MARKER}>
      <div className={styles.cluster} style={{ '--count': items.size } as CSSProperties}>
        {items.size}
      </div>
    </MapMarker>
  )
}
